import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';

const ArrangementOffentlig = () => {
  const { slug } = useParams();
  const [data, setData] = useState(null);
  const [feil, setFeil] = useState('');
  const [skjema, setSkjema] = useState({ navn: '', epost: '', telefon: '', kommentar: '' });
  const [sendt, setSendt] = useState(false);

  useEffect(() => {
    axios.get(`/api/p/arrangement/${slug}`)
      .then((r) => setData(r.data))
      .catch((e) => setFeil(e.response?.data?.error || 'Arrangementet finnes ikke.'));
  }, [slug]);

  const meldPa = async (e) => {
    e.preventDefault();
    try {
      await axios.post(`/api/p/arrangement/${slug}/paameld`, skjema);
      setSendt(true);
    } catch (err) {
      alert('Feil: ' + (err.response?.data?.error || err.message));
    }
  };

  if (feil) return <div style={{ padding: 40, textAlign: 'center', fontFamily: 'system-ui' }}><h2>{feil}</h2></div>;
  if (!data) return <div style={{ padding: 40, textAlign: 'center' }}>Laster…</div>;

  return (
    <div style={{ maxWidth: 640, margin: '40px auto', padding: 24, fontFamily: 'system-ui' }}>
      <h1>{data.navn}</h1>
      <p style={{ color: '#666' }}>{data.firma_navn}</p>

      <div style={{ background: '#f6f8fa', padding: 20, borderRadius: 8, margin: '20px 0' }}>
        {data.start && <p><strong>Når:</strong> {new Date(data.start).toLocaleString('nb-NO')}{data.slutt ? ` – ${new Date(data.slutt).toLocaleString('nb-NO')}` : ''}</p>}
        {data.sted && <p><strong>Sted:</strong> {data.sted}</p>}
        {data.krever_betaling && <p><strong>Pris:</strong> {data.pris} kr</p>}
        {data.maks_deltakere > 0 && (
          <p><strong>Plasser:</strong> {data.antall_paameldte} / {data.maks_deltakere}</p>
        )}
      </div>

      {data.beskrivelse && (
        <div style={{ whiteSpace: 'pre-wrap', marginBottom: 24 }}>{data.beskrivelse}</div>
      )}

      {sendt ? (
        <div style={{ background: '#d4edda', color: '#155724', padding: 16, borderRadius: 6 }}>
          Takk for påmeldingen! Du vil få en bekreftelse på e-post.
        </div>
      ) : data.pamelding_aapen ? (
        <form onSubmit={meldPa}>
          <h2>Meld deg på</h2>
          <input required placeholder="Fullt navn" value={skjema.navn}
                 onChange={(e) => setSkjema({ ...skjema, navn: e.target.value })}
                 style={{ width: '100%', padding: 12, marginBottom: 10, border: '1px solid #ccc', borderRadius: 6 }} />
          <input required type="email" placeholder="E-post" value={skjema.epost}
                 onChange={(e) => setSkjema({ ...skjema, epost: e.target.value })}
                 style={{ width: '100%', padding: 12, marginBottom: 10, border: '1px solid #ccc', borderRadius: 6 }} />
          <input placeholder="Telefon" value={skjema.telefon}
                 onChange={(e) => setSkjema({ ...skjema, telefon: e.target.value })}
                 style={{ width: '100%', padding: 12, marginBottom: 10, border: '1px solid #ccc', borderRadius: 6 }} />
          <textarea placeholder="Kommentar / allergier" rows={3} value={skjema.kommentar}
                    onChange={(e) => setSkjema({ ...skjema, kommentar: e.target.value })}
                    style={{ width: '100%', padding: 12, marginBottom: 10, border: '1px solid #ccc', borderRadius: 6 }} />
          <button type="submit" style={{ width: '100%', padding: 14, background: '#0066cc', color: '#fff', border: 0, borderRadius: 6, fontSize: 16, cursor: 'pointer' }}>
            Meld meg på
          </button>
        </form>
      ) : (
        <div style={{ background: '#fff3cd', color: '#856404', padding: 16, borderRadius: 6 }}>
          Påmelding er stengt.
        </div>
      )}
    </div>
  );
};

export default ArrangementOffentlig;
